// app/javascript/controllers/input_sanitizer_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  sanitize(event) {
    const input = event.target;
    let value = input.value;

    // Allow only digits
    value = value.replace(/[^0-9]/g, '');

    // Remove leading zeros (but keep single "0")
    if (value.length > 1 && value.startsWith('0')) {
      value = value.replace(/^0+/, '') || '0';
    }

    // Cap the value at 100,000,000
    if (parseInt(value, 10) > 100000000) {
      value = '100000000';
    }

    // Update input value without dispatching events to prevent loops
    input.value = value;
  }
}
